module.exports = __webpack_public_path__ + "img/dea-formazione-ico-clil.c4ba3478.svg";